import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/capa/(pages)/(list)/actions')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/capa/actions' ||
      location.pathname === '/capa/actions/'
    ) {
      throw redirect({ to: '/capa/actions/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/ActionsLayout'),
    'ActionsLayout',
  ),
});
